import PhoneInputLib, { CountryData } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './PhoneInput.css';

import { cn } from '@/utils';

export type PhoneData = {
  countryCode: string;
  phoneNumber: string;
  country: string;
  fullNumber: string;
};

type PhoneInputProps = {
  className?: string;
  value?: string;
  defaultCountry?: string;
  onChange?: (data: PhoneData) => void;
  disabled?: boolean;
};

const PhoneInput = ({ className, onChange, value, defaultCountry, disabled }: PhoneInputProps) => {
  const handleChange = (value: string, data: CountryData | Record<string, never>) => {
    const country = data as CountryData;
    const dialCode = country?.dialCode ?? '';

    const phoneData: PhoneData = {
      countryCode: dialCode ? `+${dialCode}` : '',
      phoneNumber: dialCode ? value.slice(dialCode.length) : value,
      country: country?.countryCode ? country.countryCode.toUpperCase() : '',
      fullNumber: value ? `+${value}` : '',
    };

    onChange?.(phoneData);
  };

  return (
    <PhoneInputLib
      inputProps={{ name: 'phone', autoComplete: 'tel' }}
      value={(value || '').replace(/^\+/, '')}
      country={(defaultCountry || 'bd').toLowerCase()}
      onChange={handleChange}
      disabled={disabled}
      enableSearch
      disableSearchIcon
      searchPlaceholder="Search country..."
      searchNotFound="No country found."
      specialLabel=""
      containerClass={cn('custom-phone-input', className)}
    />
  );
};

export default PhoneInput;
